module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/r3Ixpq/tc-custom/9781626810471.jpg?1704316521701",
      "alt": "This image is the cover for the book Newmarket Match"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Newmarket Match\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A winning Regency that sets horses—and hearts—racing from the author of the Fire series, “a brilliant star of the romance genre” ("), _c('i', [_vm._v("RT Book Reviews")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" A shy country miss, Harriet Rowe is sure she has little to offer her step-cousin, the dashing Lord Richard Standen. The most handsome gentleman in London, he can have whatever he wants—except for a racehorse that’s just out of his monetary reach."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Eager to stay close to the man who has won her heart, even if he doesn’t know it, Harriet offers to lend Richard the money for the racehorse, making them partners on the racecourse. But if Harriet wants to be a partner with Richard for life, she will have to remove her blinders and join the wild race for romance, with Richard as her prize.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Anita Mills\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Diversion Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0